import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  AgreeWithPolicy,
  Body,
  Header,
  PrivacyLink,
  PrivacyText,
  ResendButton,
} from "./styled";
import { loginApi, sendCodeApi } from "../../../redux/Slice/authSlice";
import Typography from "../../Typography";
import { Button } from "../../Button/Button";
import IconButton from "../../IconButton";
import { CodeInput } from "../../CodeInput/CodeInput";
import { Xmark } from "../assets/Xmark";
import { Checkbox } from "../../Checkbox";

const INITIAL_TIME = 60;

export const CodeStep = ({
  email,
  field,
  isUserExists,
  onChange,
  handleSubmit,
  onClose,
  setError,
}) => {
  const [loginLoading, setLoginLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [time, setTime] = useState(INITIAL_TIME);
  const intervalId = useRef();
  const dispatch = useDispatch();

  const handleLogin = async (data, e) => {
    e.preventDefault();

    try {
      setLoginLoading(true);
      await dispatch(loginApi(data)).unwrap();
      onClose();
    } catch (error) {
      setError("code", "Неправильный код");
    } finally {
      setLoginLoading(false);
    }
  };

  const handleResendCode = async (data) => {
    try {
      setResendLoading(true);
      await dispatch(sendCodeApi(data.email)).unwrap();
      setTime(INITIAL_TIME);
    } catch (error) {
      setError("code", "Неправильный код");
    } finally {
      setResendLoading(false);
    }
  };

  useEffect(() => {
    if (time <= 0) {
      clearInterval(intervalId.current);
      return;
    }

    intervalId.current = setInterval(() => {
      setTime((prev) => prev - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId.current);
    };
  }, [time]);

  const isRegisterButtonDisabled = !isUserExists
    ? field.value.length < 4 || !isAgreed // Для регистрации: код < 4 ИЛИ не согласен с политикой
    : field.value.length < 4;

  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <Header>
        <Typography variant="h2" color="primary">
          {isUserExists ? "Авторизация" : "Регистрация"}
        </Typography>
        <IconButton onClick={onClose}>
          <Xmark />
        </IconButton>
      </Header>
      <Body>
        <Typography variant="body1" color="primary">
          Мы отправили на вашу почту{" "}
          <Typography color="orange">{email}</Typography> код подтверждения.
        </Typography>
        <CodeInput onChange={onChange} {...field} />
        <Button
          variant="orange"
          width="100%"
          disabled={isRegisterButtonDisabled}
          loading={loginLoading}
          type="submit"
        >
          {isUserExists ? "Войти" : "Зарегистрироваться"}
        </Button>
        {!isUserExists && (
          <AgreeWithPolicy>
            <Checkbox
              checked={isAgreed}
              onChange={() => setIsAgreed(!isAgreed)}
            />
            <PrivacyText color="whiteSecondary">
              Я согласен(а) на обработку персональных данных в соответствии с{" "}
              <PrivacyLink to="/policy-privacy" target="_blank">
                Политикой конфиденциальности
              </PrivacyLink>
            </PrivacyText>
          </AgreeWithPolicy>
        )}
        <ResendButton
          onClick={handleSubmit(handleResendCode)}
          disabled={resendLoading || time !== 0}
          type="button"
        >
          <Typography color="inherit">
            {time === 0
              ? "Отправить код повторно"
              : `Отправить код повторно через ${time}с`}
          </Typography>
        </ResendButton>
      </Body>
    </form>
  );
};
